import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-0df58204"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container-xl" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-plus" }, null, -1));
import PostList from '../../components/crud/PostList.vue';
import { ModalsContainer, useModal } from 'vue-final-modal';
import ModalUser from '../../components/crud/ModalUser.vue';
import 'vue-final-modal/style.css';
import '../../assets/styles/boot.min.css';
import '../../assets/styles/font.min.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PostManagement',
    props: {
        title: String
    },
    emits: ['editItem'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const editItem = async (_user) => {
            emit('editItem', _user);
        };
        // Use the useModal hook to create modal handling functions
        const { close } = useModal({
            component: ModalUser,
            attrs: {
                onConfirm() {
                    close();
                },
            },
            slots: {
                default: '<p>The content of the modal</p>',
            },
        });
        return (_ctx, _cache) => {
            const _component_VButton = _resolveComponent("VButton");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_VButton, {
                        onClick: _cache[0] || (_cache[0] = ($event) => (editItem({ id: null })))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_2,
                            _createTextVNode(),
                            _createElementVNode("span", null, "Add " + _toDisplayString(__props.title), 1)
                        ]),
                        _: 1
                    })
                ]),
                _createVNode(PostList, {
                    title: __props.title,
                    onEditItem: editItem
                }, null, 8, ["title"]),
                _createVNode(_unref(ModalsContainer))
            ]));
        };
    }
});
